const capitalize = function(text)
{
	if (text?.toLowerCase)
	{
		text = text.toLowerCase();
		text = text.replace(/(?:^|[^a-záéíóúâêôãõàüç])[a-záéíóúâêôãõàüç]/g, (a) => a.toUpperCase());
		text = text.replace(/(^\w{1,3}\d?(?:\s|$)|(?<=\(.*)\b\w{2,3}\b(?=.*\)))/gi, (a) => (/Av|Al|Rua|Rod|Via|Est/i.test(a) ? a : a.toUpperCase()));	// Siglas
		text = text.replace(/(\s(?:e|de|da|do|das|dos)\s)/gi, (a) => a.toLowerCase());											// Conectores
		text = text.replace(/(\s(?:S\/A|S\/C|ME|EPP|EIRELI)\b)/gi, (a) => a.toUpperCase());										// Empresas
		text = text.replace(/(\b(?:BR|AC|AL|AM|AP|BA|CE|DF|ES|GO|MA|MT|MS|MG)(?=.\d))/gi, (a) => a.toUpperCase());				// Rodovias
		text = text.replace(/(\b(?:PA|PB|PR|PE|PI|RN|RS|RJ|RO|RR|SC|SP|SE|TO)(?=.\d))/gi, (a) => a.toUpperCase());
		text = text.replace(/(\b(?:I|II|III|IV|V|VI|VII|VIII|IX|X|XI|XII|XIII|XIV)\b)/gi, (a) => a.toUpperCase());				// Romanos
		text = text.replace(/(\b(?:XV|XVI|XVII|XVIII|XIX|XX|XXI|XXII|XXIII|XXIV|XXV)\b)/gi, (a) => a.toUpperCase());
		text = text.replace(/(\d(?:ml|mcg|mg|g|kg|mm|cm|m|km)\b)/gi, (a) => a.toLowerCase());									// Unidades
		text = text.replace(/(\d(?:l)\b)/gi, (a) => a.toUpperCase());															// Unidades
		text = text.replace(/(\bPM\b)/gi, (a) => a.toUpperCase());																// Diversos
	}
	return text;
}

const round = function(number, places)
{
	let scale = Math.pow(10, places);							// 1, 10, 100, 1000 ...
	let scaled = number * scale;								// 1.2359 * 100 = 123.59
	let trunc = Math.trunc(scaled);								// 123.59 = 123
	let rest = scaled - trunc;									// 123.59 - 123 = 0.59
	if (rest > 0)
	{
		let next_digit = Math.trunc(rest * 10);					// 0.59 * 10 = 5.9 -> trunc(5.9) -> 5
		let zero_or_one = Math.floor(next_digit / 10 * 2);		// 5 / 10 = 0.5 * 2 = 1 -> floor(1) -> 1
		trunc += zero_or_one;									// 123 + 1 = 124
	}
	return trunc / scale;										// 124 / 100 -> 1.24
};

const removeEvents = function(node)
{
	let clone = node.cloneNode(true);
	node.replaceWith(clone);
	return clone;
};

const findByName = function(node, name)
{
	for (; node && node.nodeName != '#document'; node = node.parentNode)
		if (node.nodeName == name.toUpperCase())
			return node;
};

const findByAttr = function(node, attribute)
{
	for (; node && node.nodeName != '#document'; node = node.parentNode)
		if (node.hasAttribute(attribute))
			return node;
};

const getUniqueId = function()
{
	return Math.random().toString().slice(-4) + Date.now().toString().slice(-12);
};

const makePassword = function()
{
	return crypto.getRandomValues(new BigUint64Array(1))[0].toString(36);
};

const splitIdsByCompany = function(ids)
{
	let split = {};
	ids.forEach(id =>
	{
		if (!split[id[0]])
			split[id[0]] = [];
		split[id[0]].push(id[1]);
	});
	return split;
};

const stringify = function(data)
{
	return JSON.stringify(data).replaceAll('"', "'");
};

const parse = function(text)
{
	let result;
	try
	{
		result = JSON.parse(text.replaceAll("'", '"'));
	}
	catch (e)
	{
		result = text;
	}
	return result;
};

/** Lote fabricante é texto (ex.: 746E4, 606E4). Não interpretar E/D como expoente. */
const formatLotNumber = function(val)
{
	if (val == null || val === undefined) return '';
	if (typeof val === 'number')
	{
		if (!isFinite(val)) return '';
		if (Number.isInteger(val) || val === Math.trunc(val))
			return String(Math.trunc(val));
		return String(val);
	}
	return String(val).trim();
};

/**
 * Resolve o id numérico da impressora para APIs de etiqueta.
 * O datalist exibe o nome (label) no input; o valor interno às vezes não sincroniza antes do submit.
 * raw: valor vindo do form.getValues(); inputSelector: ex. '#stocks-select-printer #device_id'
 */
const resolvePrinterDeviceId = function(raw, inputSelector)
{
	const toNum = (x) =>
	{
		const n = Number(x);
		return !isNaN(n) && n >= 0 ? n : null;
	};
	if (raw != null && raw !== '' && raw !== -1 && raw !== '-1')
	{
		const n = toNum(raw);
		if (n != null)
			return n;
	}
	const node = typeof inputSelector === 'string' ? document.querySelector(inputSelector) : inputSelector;
	if (!node?.list?.options?.length)
		return null;
	const trimmed = String(node.value ?? '').trim();
	if (!trimmed)
		return null;
	const options = Array.from(node.list.options);
	let opt = options.find(o => o.innerText && o.innerText.trim() === trimmed);
	if (!opt && /^\d+$/.test(trimmed))
		opt = options.find(o => String(o.value) === trimmed);
	return opt ? toNum(opt.value) : null;
};

export { capitalize, round, removeEvents, findByName, findByAttr, getUniqueId, splitIdsByCompany, makePassword, stringify, parse, formatLotNumber, resolvePrinterDeviceId };

